import React from "react";

const Kotlin_Syllabus = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Syllabus</h1>
      <p>Content for Kotlin Syllabus goes here.</p>
    </div>
  );
};

export default Kotlin_Syllabus;
